import { ColorName, ListSubItem } from 'types';

import { useAppSelector } from 'redux/hooks';

import { ButtonMotives } from 'components/Button';

import * as S from '../../Dropdown.styles';

type SubDropdownProps = {
  items: ListSubItem[];
  itemMotive: ButtonMotives;
};

export function SubDropdown(props: SubDropdownProps): React.ReactElement {
  const { items, itemMotive } = props;
  const { barColor } = useAppSelector((state) => state.settings);

  return (
    <S.List data-testid="list">
      {items.map((menuItem: ListSubItem) => (
        <S.ListItem
          // hasAnimation={hasAnimation}
          // itemsHasBorder={itemsHasBorder}
          key={menuItem.label}
        >
          {menuItem.label && (
            <S.ListItemButton
              iconLeft={menuItem.iconLeft}
              iconRight={menuItem.iconRight}
              motive={itemMotive}
              asLink={menuItem.to !== 'undefined'}
              to={menuItem.to}
              scale="xs"
              onClick={menuItem.onClick}
              fontWeight="extraLight"
              fontFamily="LFT Zeno"
              whiteSpace="normal"
              barColor={barColor as ColorName}
            >
              {menuItem.label}
            </S.ListItemButton>
          )}
        </S.ListItem>
      ))}
    </S.List>
  );
}
